import styled from 'styled-components';
import { tokens } from '../../../../design/tokens';

export const FileList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
`;

export const FileRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  flex-wrap: wrap;
`;

export const HiddenFileInput = styled.input`
  display: none;
`;

export const FileInputLabel = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  border: 1px dashed ${tokens.color.marqueeGold};
  border-radius: ${tokens.radius.sm};
  color: ${tokens.color.marqueeGold};
  font-size: ${tokens.font.body.size};
  font-weight: 500;
  white-space: nowrap;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background: rgba(254, 212, 74, 0.1);
  }
`;

export const FileMeta = styled.span`
  color: ${tokens.color.textAsh};
  font-size: ${tokens.font.caption.size};
  white-space: nowrap;
`;

export const StatusBadge = styled.span<{ status: 'pending' | 'uploading' | 'done' | 'error' }>`
  font-size: ${tokens.font.caption.size};
  font-weight: 600;
  white-space: nowrap;
  color: ${({ status }) =>
    status === 'done'
      ? tokens.color.marqueeGold
      : status === 'error'
      ? tokens.color.errorRed
      : tokens.color.textAsh};
`;

export const ProgressTrack = styled.div`
  width: 100%;
  height: 4px;
  margin-top: 4px;
  border-radius: 2px;
  background: ${tokens.color.railGraphite};
  overflow: hidden;
`;

export const ProgressFill = styled.div<{ progress: number }>`
  height: 100%;
  width: ${({ progress }) => progress}%;
  background: ${tokens.color.marqueeGold};
  transition: width 0.2s ease;
`;

export const RemoveButton = styled.button`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: 1px solid ${tokens.color.errorRed};
  border-radius: ${tokens.radius.xs};
  background: transparent;
  color: ${tokens.color.errorRed};
  cursor: pointer;
  transition: background-color 0.2s, color 0.2s;

  &:hover {
    background: ${tokens.color.errorRed};
    color: #fff;
  }

  &:focus-visible {
    outline: 2px solid ${tokens.color.focusAmber};
    outline-offset: 2px;
  }
`;
export const AddButton = styled.button`
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
  padding: 8px 14px;
  border: 1px dashed ${tokens.color.marqueeGold};
  border-radius: ${tokens.radius.sm};
  background: transparent;
  color: ${tokens.color.marqueeGold};
  font-size: ${tokens.font.body.size};
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background: rgba(254, 212, 74, 0.1);
  }

  &:focus-visible {
    outline: 2px solid ${tokens.color.focusAmber};
    outline-offset: 2px;
  }
`;
